import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=7386f60c"
import script from "./Properties.vue?vue&type=script&lang=js"
export * from "./Properties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports